module.exports = __webpack_public_path__ + "td/img/home-run.b23700b6.png";